export function resolveHashTargetId(hash: string): string | null {
  if (!hash || hash.length < 2) {
    return null;
  }

  const raw = hash.slice(1);
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

export function resolveFlashElement(element: Element): Element {
  return element.closest('section.feature-disclaimer-card') || element;
}

/** Sticky marketing navbar clearance for hash deep-links. */
export const HASH_TARGET_SCROLL_OFFSET_PX = 96;

export function scrollHashTargetIntoView(
  element: Element,
  offsetPx = HASH_TARGET_SCROLL_OFFSET_PX,
): void {
  const target = resolveFlashElement(element) as HTMLElement;
  const top = target.getBoundingClientRect().top + window.scrollY - offsetPx;
  window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
}

export function applyHashTargetFlash(element: Element, timeoutMs = 1600): () => void {
  const flashEl = resolveFlashElement(element);
  if (!flashEl.hasAttribute('tabindex')) {
    flashEl.setAttribute('tabindex', '-1');
  }

  try {
    scrollHashTargetIntoView(flashEl);
  } catch {
    // no-op
  }

  let timeoutId: number | undefined;
  const frameId = window.requestAnimationFrame(() => {
    // Re-apply after layout/fonts settle so the sticky header cannot cover the card.
    try {
      scrollHashTargetIntoView(flashEl);
    } catch {
      // no-op
    }
    try {
      (flashEl as HTMLElement).focus({ preventScroll: true });
    } catch {
      try {
        (flashEl as HTMLElement).focus();
      } catch {
        // no-op
      }
    }
    flashEl.classList.add('hash-target-flash');
    timeoutId = window.setTimeout(() => {
      flashEl.classList.remove('hash-target-flash');
    }, timeoutMs);
  });

  return () => {
    window.cancelAnimationFrame(frameId);
    if (timeoutId !== undefined) {
      window.clearTimeout(timeoutId);
    }
    flashEl.classList.remove('hash-target-flash');
  };
}
